import VuexPersist from 'vuex-persist'

export default new VuexPersist({
    key: '75bc8e96-6260-4593-b08f-04b093b76a6a',
    storage: window.localStorage,
    reducer: state => ({
      authModule: state.authModule,
      formResultModule: {
        formResultsFilter: state.formResultModule.formResultsFilter,
        formResultsSortBy: state.formResultModule.formResultsSortBy,
        formResultsSortDesc: state.formResultModule.formResultsSortDesc,
        formResultsPageSize: state.formResultModule.formResultsPageSize,
      },
      planModule: state.planModule,
      publicModule: state.publicModule,
      searchModule: {
        query: state.searchModule.query,
        searches: state.searchModule.searches,
        filters: state.searchModule.filters,
        useActive: state.searchModule.useActive,
        useCache: state.searchModule.useCache,
        enabledFilters: state.searchModule.enabledFilters,
      },
      signupModule: state.signupModule,
      towerModule: { towers: state.towerModule.towers },
    }),
})
